import styled from 'styled-components';
import { defaultColors } from '@components/themes';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { Flex } from '@components/Flex';
import { themeMediaQuery, themeColor } from '@utils/styledTheme.util';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';

export const SectionWrapperBox = styled(Box)`
  background-color: white;
  ${themeMediaQuery('below_sm')} {
    background-color: ${themeColor('accentBlue6')};
  }
`;

export const Tag = styled(Text)`
  border: 1px solid ${defaultColors.purple3};
  border-radius: 4px;
  padding: 4px 16px;
  width: 160px;
  text-align: center;
  margin-top: 12px;
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

export const TagsWrapper = styled(Box)`
  position: relative;
  ${themeMediaQuery('below_sm')} {
    height: 220px;
  }
`;

export const TagsAnimation = styled.div`
  position: absolute;
  height: 100%;
  will-change: transform;
`;

export const Wrapper = styled.div`
  max-width: 1440px;
  margin: auto;
`;

export const ImageWrapper = styled(Flex)`
  width: 200px;
  ${themeMediaQuery('below_sm')} {
    width: 105px;
  }
`;

export const TagImage = styled(PlaceholderCloudImage)`
  display: block;
  width: 188px;
  height: 101px;
  ${themeMediaQuery('below_sm')} {
    display: none;
    width: 1px;
    height: 1px;
  }
`;

export const TagImageMobile = styled(PlaceholderCloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    width: fit-content;
    height: 100%;
  }
`;

export const TagWrapper = styled(Box)`
  position: relative;
  height: 1160px;
  ${themeMediaQuery('below_sm')} {
    height: auto;
  }
`;

export const TagGuestWrapper = styled(Box)`
  max-width: 100%;
  align-self: center;
  margin: auto;
`;

export const TextPairingWrapper = styled(TextPairing)`
  max-width: 100%;
  width: 380px;
  margin: auto;
  ${themeMediaQuery('xl')} {
    width: 520px;
  }
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const TextPairingWrapperMobile = styled(TextPairing)`
  max-width: 100%;
  width: 380px;
  margin: auto;
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
  .text-pairing-body {
    ${themeMediaQuery('below_sm')} {
      width: 100%;
    }
  }
`;

export const DesktopWrapper = styled.div`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const MobileWrapper = styled.div`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;
